import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FixedAgent from "../../utils/api/FixedAgent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const UpdateConfirmation = () => {
  const location = useLocation();
  useEffect(() => {
    const fetchData = async () => {
      const params = new URLSearchParams(location.search);
      const correctionId = params.get("correction_id");
      if (correctionId) {
        if (FixedAgent.ceiUpdate) {
          try {
            await FixedAgent.ceiUpdate({
              correction_id: correctionId,
            });
            toast.success("Data updated successfully!");
          } catch (error) {
            toast.error(error?.response?.data?.message, {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              progress: undefined,
              style: {
                backgroundColor: "#FFFFFF",
                color: "#000000",
              },
            });
          }
        }
      }
    };

    fetchData();
  }, [location.search]);

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ToastContainer />

      <h2>Thanks for updating the data.</h2>
      <p>Your update has been received.</p>
    </div>
  );
};

export default UpdateConfirmation;
